/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Knp_Lookup_Add_Term_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to add term: {message}" |
*
* @param {Knp_Lookup_Add_Term_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_add_term_failed_toast = /** @type {((inputs: Knp_Lookup_Add_Term_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Add_Term_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'ajout du terme : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Term konnte nicht hinzugefügt werden: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile aggiungere il termine: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось добавить термин: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo agregar el término: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`添加术语失败：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`用語の追加に失敗しました: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टर्म जोड़ने में विफल: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao adicionar o termo: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Failed to add term: ${i?.message}`)
});